export const Bio = {
  name: "Pradyuman Sharma",
  roles: [
    "Full Stack Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "Full stack developer focused on building fast, accessible, and reliable web applications. Experienced in delivering complete features from intuitive UI development to secure backend integrations. Enjoys working with teams, sharing knowledge, and solving real world problems through software.",
  github: "https://github.com/Pradyuman072",
  resume:
    "https://drive.google.com/drive/u/0/folders/17swV23kAZ_g6DA770XOPn4JMXifZi4c4",
  linkedin: "https://in.linkedin.com/in/pradyuman-sharma-273a8531a?trk=people-guest_people_search-card",
 
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "ReactJs",
      },
      {
        name: "Next Js",
        image: "https://cdn.worldvectorlogo.com/logos/next-js.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TypeScript",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      },
      {
        name: "Tailwind CSS",
        image: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
     ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "ExpressJs",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "MATLAB",
        image: "https://upload.wikimedia.org/wikipedia/commons/2/21/Matlab_Logo.png",
      },
      {
        name: "Arduino",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/arduino/arduino-original.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://images.app.goo.gl/bSU1TGuAHc2jVtXg8",
    role: "Executive Member and Web Developer",
    company: "Team Ojas, NIT Hamirpur",
    date: "Jan 2025 - Apr 2025",
    desc: "Designed and deployed the official team website improving engagement and visibility among 1000 plus students. Organized sessions on JavaScript, MATLAB and IoT based API workflows for 100 plus learners.",
  },
  {
    id: 1,
    img: "https://images.app.goo.gl/bSU1TGuAHc2jVtXg8",
    role: "Executive Member ",
    company: "Elsoc Nit Hamirpur",
    date: "Oct 2024 - Present",
    desc: "Contributed to different projects and software initiatives improving accessibility on campus.",
  },
];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/b/b8/National_Institute_of_Technology%2C_Hamirpur_Logo.png",
    school: "National Institute of Technology Hamirpur",
    date: "Aug 2023 - May 2027",
    grade: "8.85 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Electrical Engineering at National Institute of Technology Hamirpur. I have a CGPA of 8.85. I am also a member of Team Ojas and ELSOC, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Electrical Engineering",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/en/e/eb/DAV_CMC_Logo.svg",
    school: "Dayanand Public School, Shimla",
    date: "Apr 2020 - May 2023",
    grade: "95.02%",
    desc: "I completed my class 12 high school education at Dayanand Public School, Shimla, where I studied Science with Computer Science.",
    
  },
];

export const projects = [
  {
    id: 0,
    title: "IllumiTrace Smart PCB Soldering Assistant",
    date: "2025",
    image: "/projects/illumitrace.png",
    tags: [
      "Next.js",
      "Arduino",
      "Computer Vision",
    ],
    description: "Built a guided soldering interface reducing component placement mistakes by 40%. Developed real time feedback system for efficient PCB prototyping.",
    category: "web app",
    github: "https://github.com/Pradyuman072",
  },
  {
    id: 1,
    title: "GovConnect Citizen Issue Reporting Platform",
    date: "2025",
    image: "/projects/govconnect.png",
    tags: [
      "MERN Stack",
      "JWT",
      "MongoDB",
    ],
    description: "Enabled secure login, geotagging and media support for reporting civic issues. Developed analytics dashboard improving issue tracking for authorities.",
    category: "web app",
    github: "https://github.com/Pradyuman072",
  },
  {
    id: 2,
    title: "Team Ojas Website",
    date: "2025",
    image: "/projects/ojas.png",
    tags: [
      "Next.js",
      "Node.js",
      "Tailwind CSS",
    ],
    description: "Delivered a responsive platform with improved SEO and optimized performance. Integrated secure APIs enabling dynamic updates to event details.",
    category: "web app",
    github: "https://github.com/Pradyuman072",
  },
];